import FluxUtils from 'flux/utils';
import Immutable from 'immutable';

import type { ActionType } from 'sharedreact/actions/generic/actions';
import ErrorConstants from 'sharedreact/constants/ErrorConstants';
import ErrorData from 'sharedreact/data/ErrorData';
import AppDispatcher from 'sharedreact/dispatcher/AppDispatcher';

const Content: {
  errors: Immutable.List<ErrorData>,
  warnings: Immutable.List<ErrorData>
} = {
  errors: Immutable.List(),
  warnings: Immutable.List()
};

class State extends Immutable.Record(Content){
}

class ErrorStore extends FluxUtils.ReduceStore<State, ActionType> {
  constructor () {
    super(AppDispatcher);
  }

  override getInitialState (): State {
    return new State();
  }

  getErrors (): Immutable.List<ErrorData> {
    return this.getState().errors;
  }

  getWarnings (): Immutable.List<ErrorData> {
    return this.getState().warnings;
  }

  override reduce (state: State, action: ActionType): State {
    switch (action.actionType) {
      case ErrorConstants.CLEAR_ERROR: {
        return state.set('errors', state.errors.shift());
      }
      case ErrorConstants.CLEAR_WARNING: {
        return state.set('warnings', state.warnings.shift());
      }
      case ErrorConstants.SET_ERROR:
      case ErrorConstants.SET_WARNING:
      default: {
        // only store errors without a validation path
        if (action.error != null && (action.error.validationPath.size === 0)) {
          if (state.errors.findIndex((error) => error.message === action.error.message && Immutable.is(error.messageParams, action.error.messageParams)) === -1) {
            return state.set('errors', state.errors.push(action.error));
          }
        }
        // only store warnings without a validation path
        if (action.warning != null && (action.warning.validationPath.size === 0)) {
          if (state.warnings.findIndex((error) => error.message === action.warning.message && Immutable.is(error.messageParams, action.error.messageParams)) === -1) {
            return state.set('warnings', state.warnings.push(action.warning));
          }
        }
        return state;
      }
    }
  }
}

export default new ErrorStore();
